module.exports = __webpack_public_path__ + "static/media/EDUOption-dark.6519ac5e.png";